import type { BrandJson } from "@coras-io/brand-tokens";
import {
  SITE_CURRENCIES,
  SITE_LOCALES,
  type SiteConfig,
} from "../../src/types";
import brandConfig from "./brand.json";

// Brand note: the original styles shipped a primary *ramp*
// (--coras-color-primary-10…120) rather than a semantic token. The darkest
// readable stop (#2998c3, primary-120) becomes the single `primary`; the new
// token system regenerates the ramp from it.
export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "664aa70a-53fc-42e8-a375-14a1916b3118",
  title: "TicketABC",
  description: "Book tickets to West End Shows, Concerts and more",
  locale: "en-IE",
  currency: "EUR",
  // Every language and currency: this is the only microsite on sandbox, so it
  // is where Arabic, right-to-left and SAR get tested.
  locales: SITE_LOCALES,
  currencies: SITE_CURRENCIES,
  favicons: ["favicon-16x16.png", "favicon-32x32.png", "favicon.ico"],
  logo: "/assets/images/logo.svg",
  domain: "ticketabc.com",
  detectLocale: true,
  detectCurrency: true,
};
